import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { GUIDE_LIST } from "../content/guides";
import { useSeo } from "../lib/seo";

export default function Guides() {
  useSeo({
    title: "Guides — Pricing & Profitability for Sellers | ProfitMigo",
    description: "Practical guides on Meesho profit, COD & RTO, reducing returns and comparing marketplace fees for Indian e-commerce sellers.",
    path: "/guides",
  });

  return (
    <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Guides" }]} />
      <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">Guides</h1>
      <p className="mt-4 text-lg text-muted-foreground">
        Short, practical explainers that pair with our calculators. We publish a guide only when it genuinely helps you price and profit better — quality over quantity.
      </p>

      <div className="mt-8 space-y-4">
        {GUIDE_LIST.map((g) => (
          <Link
            key={g.slug}
            to={`/guides/${g.slug}`}
            className="group block rounded-lg border border-border bg-card p-5 transition-colors hover:border-primary"
            data-testid={`guide-link-${g.slug}`}
          >
            <div className="flex items-start gap-3">
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent text-primary">
                <BookOpen className="h-4 w-4" />
              </span>
              <div>
                <div className="font-display text-lg font-semibold group-hover:text-primary">{g.title}</div>
                <p className="mt-1 text-sm text-muted-foreground">{g.description}</p>
              </div>
              <ArrowRight className="ml-auto mt-1 h-4 w-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-1 group-hover:text-primary" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
